import { useState } from "react";
import Notify from "devextreme/ui/notify";
//DBTables
import { DBModule, ModuleTypeId } from "../../../types/DBTables";
import { UseFormReturn } from "react-hook-form";

import NumberEditor from "../../Global/Editors/NumberEditor";
import CheckboxEditor from "../../Global/Editors/CheckboxEditor";
import TextEditor from "../../Global/Editors/TextEditor";
import { useGlobalData } from "../../GlobalDataProvider";
import SelectEditor from "../../Global/Editors/SelectEditor";
import { DTOModule } from "../../../types/building";
import { IModuleRound, useRound } from "../../../modules/roundHandler";
import { nameof } from "../../Global/Utils";
import { IModuleLokaler, IModuleVärmeEl } from "../../../types/ModuleDatas";
import { MapTooltip } from "../../../types/globalData";
import BFLNote from "../BFL/BFLNote";

interface IProps {
  module: IModuleRound;
  data: any;
  formHook: UseFormReturn;
}

const RoundDirektverkandeEL = ({ module, data, formHook }: IProps) => {
  const globalData = useGlobalData();
  const roundHandler = useRound();

  const isSummer = roundHandler.getActiveRound()?.isSummer as boolean;

  const moduleData = data as IModuleVärmeEl;
  const hasVärmeStop = moduleData.harÖverordnatVärmestopp === "Ja";

  const lokalerModule = roundHandler.getRoundData()?.data.modules.find((m) => m.moduleTypeId === ModuleTypeId.Lokaler);
  const lokalerModuleData = lokalerModule?.data as IModuleLokaler;
  const stickprovThisModule = lokalerModuleData?.stickprov.filter((s) => s.värmeSystem === module.name);
  const inställningsvärdeGenomsnitt =
    (stickprovThisModule?.reduce((acc, s) => acc + (s.inställningsvärdeTermostat ? s.inställningsvärdeTermostat : 0), 0) || 0) / (stickprovThisModule?.length || 1);

  return (
    <>
      {/* Direktverkande el */}
      <div className="row ml-0">
        {/* <div className="col-lg-12">Ange mätvärden för pågående energirondering</div> */}
        {hasVärmeStop && isSummer ? (
          <>
            <div className="col-lg-12">
              <NumberEditor
                label="Inställningsvärde värmestopp"
                fieldName={nameof<IModuleVärmeEl>("värmestoppInställningsvärde")}
                tooltipId={nameof<MapTooltip>("VärmeEl_värmestoppInställningsvärde")}
                formHook={formHook}
                options={{
                  validate: {
                    required: (value: any) => (value || value === 0 ? undefined : "Måste anges"),
                    min: (value: any) => (value && value < 10 ? "> 10 ℃" : undefined),
                    max: (value: any) => (value && value > 25 ? "< 25 ℃" : undefined),
                  },
                }}
              ></NumberEditor>
            </div>
            <div className="col-lg-12">
              <SelectEditor
                label="Funktionskontroll värmestopp"
                formHook={formHook}
                fieldName={nameof<IModuleVärmeEl>("värmestoppFunktionskontroll")}
                tooltipId={nameof<MapTooltip>("VärmeEl_värmestoppFunktionskontroll")}
                items={["", "Värmeavgivning aktiv", "Värmeavgivning ej aktiv"]}
                options={{ required: "Måste göra ett val" }}
              ></SelectEditor>
            </div>
            <SelectEditor
              label="Värmestopp aktiveras vid överskridet gränsvärde (Ja / Nej)"
              fieldName={nameof<IModuleVärmeEl>("kontrollVärmestoppFungerar")}
              tooltipId={nameof<MapTooltip>("VärmeEl_kontrollVärmestoppFungerar")}
              formHook={formHook}
              items={["", "Ja", "Nej"]}
              options={{ required: "Måste göra ett val" }}
            ></SelectEditor>
            <SelectEditor
              label="Styrande givare utetemperatur OK?"
              fieldName={nameof<IModuleVärmeEl>("kontrollGivareUtetemperaturFungerar")}
              tooltipId={nameof<MapTooltip>("VärmeEl_kontrollGivareUtetemperaturFungerar")}
              formHook={formHook}
              items={["", "Ja", "Nej"]}
              options={{ required: "Måste göra ett val" }}
            ></SelectEditor>
          </>
        ) : (
          <></>
        )}

        {isSummer ? (
          <></>
        ) : (
          <div className="col-lg-12">
            {/* <NumberEditor
              label="Inställningsvärde termostat"
              fieldName={nameof<IModuleVärmeEl>("termostatInställningsvärde")}
              tooltipId={nameof<MapTooltip>("VärmeEl_termostatInställningsvärde")}
              formHook={formHook}
              step={0.1}
              options={{
                validate: {
                  required: (value: any) => (value || value === 0 ? undefined : "Måste anges"),
                  min: (value: any) => (value && value < 10 ? "> 10 ℃" : undefined),
                  max: (value: any) => (value && value > 25 ? "< 25 ℃" : undefined),
                },
              }}
            ></NumberEditor> */}

            <NumberEditor
              label="Inställningsvärde termostat"
              fieldName={nameof<IModuleVärmeEl>("termostatInställningsvärde")}
              tooltipId={nameof<MapTooltip>("VärmeEl_termostatInställningsvärde")}
              formHook={formHook}
              isDisabled={true}
              showWhenIsDisabled={true}
            ></NumberEditor>
          </div>
        )}
      </div>
      <BFLNote formHook={formHook} />
    </>
  );
};

export default RoundDirektverkandeEL;
